import { axios } from '@Root/API'

export const get = (contactId, params) => {
	return axios.get(`contact/applications/${contactId}`, {
		params,
	})
}
